import _ from 'lodash';
import gmt from './gmt';

export default {
  mixins: [gmt],
  methods: {
    generateLink(action) {
      return {
        name: 'actions.index.detail',
        params: { id: action.id },
      };
    },
    keyValues(action) {
      return [
        {
          label: 'Name',
          field: 'name',
          value: action.name,
          link: this.generateLink(action),
        },
        {
          label: 'Description',
          field: 'description',
          value: action.description,
        },
        {
          label: 'Created',
          field: 'created',
          value: this.$options.filters.formatEpochDate(action.created, this.gmt),
        },
        {
          label: 'Modified',
          field: 'updated',
          value: this.$options.filters.formatEpochDate(action.updated, this.gmt),
        },
        {
          label: 'Cache Rentention',
          field: 'cache_retention',
          value: `${action.cacheConfig.days} Days`,
        },
        {
          label: 'GamePlan Alerting',
          field: 'gameplan_alerting',
          value: action.alertConfig.gameplan ? 'Enabled' : 'Disabled',
        },
        {
          label: 'Console Logging Alerts',
          field: 'gameplan_alerting_consoleEnabled',
          value: action.alertConfig.consoleEnabled ? 'Enabled' : 'Disabled',
        },
        {
          label: 'GamePlan Logging',
          field: 'gameplan_logging',
          value: action.logConfig.gameplan ? 'Enabled' : 'Disabled',
        },
        {
          label: 'Logging Endpoints',
          field: 'logging_endpoints',
          value: action.logConfig.endpoints.length ? _.map(action.logConfig.endpoints, e => e.url).join(', ') : '-',
        },
        {
          label: 'Console Logging Logs',
          field: 'gameplan_logging_consoleEnabled',
          value: action.logConfig.consoleEnabled ? 'Enabled' : 'Disabled',
        },
        {
          label: 'Alerting Endpoints',
          field: 'alerting_endpoints',
          value: action.alertConfig.endpoints.length ? _.map(action.alertConfig.endpoints, e => e.url).join(', ') : '-',
        },
      ];
    },
  },
};
